import { useState } from "react";
import { Star } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function FeedbackForm({ order, onDone }) {
  const [rating, setRating] = useState(5);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/feedback", { code: order.code, email: order.email, rating, text });
      toast.success("Thanks for the feedback!");
      onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="m-6 md:m-8 mb-0 p-4 border border-[#ffb020]/50 bg-[#150f03]" data-testid="feedback-form">
      <div className="overline-label !text-[#ffb020] mb-2">How was your order?</div>
      <div className="flex gap-1 mb-3" role="radiogroup" aria-label="Star rating">
        {[1, 2, 3, 4, 5].map((n) => (
          <button type="button" key={n} onClick={() => setRating(n)} aria-label={`${n} stars`} className="transition-transform hover:scale-110" data-testid={`feedback-star-${n}`}>
            <Star size={32} weight={n <= rating ? "fill" : "regular"} className={n <= rating ? "text-[#ffc72c]" : "text-[#5a4a2a]"} />
          </button>
        ))}
      </div>
      <textarea required minLength={3} maxLength={400} rows={3} className="field" placeholder="Tell us about your purchase" value={text} onChange={(e) => setText(e.target.value)} data-testid="feedback-text-input" />
      <button className="btn-bomb !py-2 mt-3" disabled={busy} data-testid="feedback-submit-button">{busy ? "Sending..." : "Post feedback"}</button>
    </form>
  );
}
